<script>
import {Doughnut} from 'vue-chartjs'


export default Doughnut.extend({
  name: 'doughnut-chart',
  data() {
    return {
      options: {
        cutoutPercentage: 75,
        responsive: false,
        responsiveAnimationDuration: 0,
        legend: {
          display: false
        },
      }
    }
  },

  props: ['chartData', 'settings'],

  mounted() {
    this.renderChart(this.chartData, this.options)
    setTimeout(() => {
      this.$emit('generateChartImage', this._chart.toBase64Image())
    }, 2000)
  }
})
</script>



// WEBPACK FOOTER //
// ChartDoughnut.vue?b22a3dbc